import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ConfirmationDeactivateService } from './shared/ConfirmationDeactivateModule/confirmationdeactivate.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}

